import {Command} from '@application/command/command';
import {getListDrawingFromProductionScheduleItem} from '@application/helper/production-schedule/get-list-drawing-from-production-schedule-item';
import {BmpProductionScheduleItemInPathGroup} from '@domain/production-schedule/bmp-production-schedule-item-in-path-group';
import {Drawing} from '@domain/production-schedule/drawing';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {AddDrawingToProductionSchedulePathCommand} from '@presentation/pages/texfab/production-schedule/add/plan/add-drawing-to-production-schedule-path-command';
import {applyChangesToNewProductionScheduleItemInPathGroup} from '@presentation/pages/texfab/production-schedule/add/plan/apply-changes-to-new-production-schedule-item-in-path-group';
import {EditProductionScheduleItemCommand} from '@presentation/pages/texfab/production-schedule/add/plan/edit-production-schedule-item-command';
import {ParametersForMovingProductionScheduleItemToProductionSchedulePath} from '@presentation/pages/texfab/production-schedule/add/plan/parameters-for-moving-production-schedule-item-to-production-schedule-path';
import {RemoveProductionScheduleItemCommand} from '@presentation/pages/texfab/production-schedule/add/plan/remove-production-schedule-item-command';
import {find, findIndex} from 'lodash-es';

export class MoveProductionScheduleItemToProductionSchedulePathCommand implements Command<ParametersForMovingProductionScheduleItemToProductionSchedulePath, ProductionSchedule> {
  public execute(commandArgs: ParametersForMovingProductionScheduleItemToProductionSchedulePath): ProductionSchedule {
    let {productionSchedule, productionScheduleItemInPathGroup} = commandArgs;
    const {
      indexInDestinationProductionSchedulePath,
      startDentOfSourceColoredYarnSet,
      sourceProductionSchedulePathNumber,
      startDentOfDestinationColoredYarnSet,
      destinationProductionSchedulePathNumber
    } = commandArgs;

    const recoloredDrawing: Drawing = productionScheduleItemInPathGroup.drawing;

    const sourceProductionSchedulePath: ProductionSchedulePath = productionSchedule.getProductionSchedulePath(sourceProductionSchedulePathNumber);
    productionScheduleItemInPathGroup = find(sourceProductionSchedulePath.pathGroups, ['uuid', productionScheduleItemInPathGroup.uuid]);

    productionScheduleItemInPathGroup.drawing = recoloredDrawing;

    productionSchedule = new RemoveProductionScheduleItemCommand().execute({
      productionSchedule,
      productionScheduleItemInPathGroupUuid: productionScheduleItemInPathGroup.uuid,
      productionSchedulePathNumber: sourceProductionSchedulePath.pathNumber,
      startDentOfColoredYarnSet: startDentOfSourceColoredYarnSet
    });

    let destinationProductionSchedulePath = productionSchedule.getProductionSchedulePath(destinationProductionSchedulePathNumber);

    productionSchedule = new AddDrawingToProductionSchedulePathCommand().execute({
      productionSchedule,
      listDrawing: getListDrawingFromProductionScheduleItem(productionScheduleItemInPathGroup, productionSchedule),
      productionSchedulePathNumber: destinationProductionSchedulePath.pathNumber,
      startDentOfColoredYarnSet: startDentOfDestinationColoredYarnSet,
      indexInProductionSchedulePath: indexInDestinationProductionSchedulePath,
      uuidForProductionScheduleInPathGroup: productionScheduleItemInPathGroup.uuid
    });

    const destinationProductionSchedulePathsOfColoredYarnSet = productionSchedule.getProductionSchedulePathsOfColoredYarnSetAtStartDent(startDentOfDestinationColoredYarnSet);
    destinationProductionSchedulePath = find(destinationProductionSchedulePathsOfColoredYarnSet.productionSchedulePaths, ['name', destinationProductionSchedulePath.name]);

    const productionSchedulePathIndex = findIndex(destinationProductionSchedulePathsOfColoredYarnSet.productionSchedulePaths, ['name', destinationProductionSchedulePath.name]);

    const newProductionScheduleItemInPathGroup: ProductionScheduleItemInPathGroup = find(
      destinationProductionSchedulePathsOfColoredYarnSet.productionSchedulePaths[productionSchedulePathIndex].pathGroups,
      ['uuid', productionScheduleItemInPathGroup.uuid]
    );

    if (
      newProductionScheduleItemInPathGroup.canBeRecolored() &&
      productionSchedule
        .getProductionSchedulePathsOfColoredYarnSetAtStartDent(startDentOfSourceColoredYarnSet)
        .productionScheduleColoredYarnSet.isEqual(destinationProductionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet)
    ) {
      newProductionScheduleItemInPathGroup.recolorDrawing({
        imageData: productionScheduleItemInPathGroup.drawing.image.data,
        commercialDimensionsInMM: productionScheduleItemInPathGroup.commercialDimensionsInMM,
        mainColorPosition: productionScheduleItemInPathGroup.mainColorPosition,
        borderColorPosition: productionScheduleItemInPathGroup.borderColorPosition,
        finishing: productionScheduleItemInPathGroup instanceof BmpProductionScheduleItemInPathGroup ? productionScheduleItemInPathGroup.finishing : null,
        mappingForDesign: productionScheduleItemInPathGroup.drawing.mappingForDesign
      });
    }

    applyChangesToNewProductionScheduleItemInPathGroup(newProductionScheduleItemInPathGroup, productionScheduleItemInPathGroup);

    return new EditProductionScheduleItemCommand().execute({
      productionSchedule,
      productionScheduleItemInPathGroup: newProductionScheduleItemInPathGroup,
      productionScheduleItemInPathGroupIndex: indexInDestinationProductionSchedulePath,
      productionSchedulePathIndex,
      startDentOfColoredYarnSet: startDentOfDestinationColoredYarnSet
    });
  }
}
